// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';
import jQuery from 'jquery';

// import Swiper styles
// import 'swiper/swiper-bundle.css';

export default class initSwiper {
  constructor() {
    this._isInit = true;
    this.addEvents()

    var pickupSlider = new Swiper('.js-swiper', {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        stopOnLastSlide: false,
      },
      // lazy: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    var carousel = new Swiper('.js-carousel', {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        stopOnLastSlide: false,
      },
      centeredSlides: true,
      slidesPerView: 2,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
       breakpoints: {
         641: {
           slidesPerView: 3,
         }
       },
       on: {
          init: function(swiper) {
            $('#top').addClass('is-visible');
          }
        }
    });

    var weekSlider = new Swiper('.js-weekSlider', {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        stopOnLastSlide: false,
      },
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    var modalSlider = new Swiper('.js-modalSlider', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    $('.js-openModalSlider').on('click', function(e) {
      $('#character_modal').addClass('is-visible');
      var index = $(this).attr('data-index');
      modalSlider.slideToLoop(Number(index), 0);
      return false;
    });

    var pjSlider = new Swiper('.js-kv-slider', {
      effect: 'fade',
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        stopOnLastSlide: false,
      },
      speed: 800,
    });
  }

  addEvents() {

  }
}
